import { render, staticRenderFns } from "./AreaItem.vue?vue&type=template&id=fe31b08c&scoped=true"
import script from "./AreaItem.vue?vue&type=script&lang=js"
export * from "./AreaItem.vue?vue&type=script&lang=js"
import style0 from "./AreaItem.vue?vue&type=style&index=0&id=fe31b08c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe31b08c",
  null
  
)

export default component.exports